import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setExtDataGroup = (payload) => ({
  type: actionTypes.SET_EXT_DATA_GROUP,
  payload
});

export const getExtDataGroups = (params) => ({
  type: actionTypes.GET_EXT_DATA_GROUPS,
  params
});

export const getExtDataGroup = (id) => ({
  type: actionTypes.GET_EXT_DATA_GROUP,
  id
});

export const createExtDataGroup = (payload) => ({
  type: actionTypes.CREATE_EXT_DATA_GROUP,
  payload
});

export const updateExtDataGroup = (payload) => ({
  type: actionTypes.UPDATE_EXT_DATA_GROUP,
  payload,
});

export const deleteExtDataGroup = (Id) => ({
  type: actionTypes.DELETE_EXT_DATA_GROUP,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});


export const setOpenModal = (isOpen) => ({
  type: actionTypes.SET_OPEN_MODAL,
  payload: isOpen,
});

export const updateExtDataGroupsOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_DATA_GROUPS_ORDER,
    payload: { orderData }
});